$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ ReactRootComponent } = require 'app/scripts/views/internal/react-root-component'
View = require 'app/scripts/views/internal/view'

module.exports = class BaseDirectoryView extends View
  initialize: ->
    @$reactRoot ?= $('<div></div>')

  renderContent: ->
    throw new Error('BaseDirectoryView renderContent method is not defined.')

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @renderContent()

  render: ->
    @$el.append(@$reactRoot)
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])
    @
